export default "images/main-background-2.jpg";